import React, { memo } from "react";
import { IconProps } from "@chakra-ui/react";
import { DynamicRulesIcon, WorldIcon } from "modules/icons";
import { isEmpty } from "lodash";
import SyncoTooltip from "../_shared/synco-tooltip";

interface IProps {
  distributionGroup: {
    isAllUsers: boolean;
    query?: string | null;
  };
  iconProps?: IconProps;
}

const DistributionGroupTypeIcon = ({
  distributionGroup,
  iconProps,
}: IProps) => {
  if (distributionGroup.isAllUsers) {
    return (
      <SyncoTooltip label="Global Group includes ALL active users in organization">
        <WorldIcon {...iconProps} />
      </SyncoTooltip>
    );
  }
  if (distributionGroup.query && !isEmpty(distributionGroup.query)) {
    return (
      <SyncoTooltip label="Group with Dynamic Rules">
        <DynamicRulesIcon {...iconProps} />
      </SyncoTooltip>
    );
  }
  return null;
};

export default memo(DistributionGroupTypeIcon);
